module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn",
    attrs: {
      "id": "help__page"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card-block col-md-5 col-lg-12"
  }, [(_vm.loadingSidebar) ? _c('loading', {
    attrs: {
      "message": "Загружаем меню помощи..."
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sidebar.content)
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: " col-12 col-lg-9"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.loadingDocument) ? _c('loading', {
    attrs: {
      "message": "Загружаем страницу помоши..."
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.document.content)
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c5c2be28", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-c5c2be28"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Help.vue
// module id = 1073
// module chunks = 1